/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_AllocationInputs */

const cs_billing_allocation = /** @type {(inputs: Billing_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alokace uživateli`)
};

const en_billing_allocation = /** @type {(inputs: Billing_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User allocation`)
};

/**
* | output |
* | --- |
* | "User allocation" |
*
* @param {Billing_AllocationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_allocation = /** @type {((inputs?: Billing_AllocationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_AllocationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_allocation(inputs)
	return cs_billing_allocation(inputs)
});